import { Injectable, Inject } from '@angular/core';
import { HttpModule, Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { APP_CONFIG, IAppConfig } from './../app.config';
import 'rxjs/add/observable/throw';

@Injectable()

export class StudentResourceService {

  private _token:string = localStorage.getItem('token');
  
  constructor(
    private http: Http, @Inject(APP_CONFIG) private config: IAppConfig
  ) {}

  
  getResourceById(rid,pid) {
    
    let token = this._token;
    let headers = new Headers({ 'Authorization': token });
    let options = new RequestOptions({ headers: headers });

    return this.http.get(this.config.apiEndpoint + 'resources/get-resource-by-id/'+rid+'/'+pid, options).map((res => res.json()))
        .catch(this.handleErrorObservable);
  }
  getResources(pid) {
    
    let token = this._token;
    let headers = new Headers({ 'Authorization': token });
    let options = new RequestOptions({ headers: headers });

    return this.http.get(this.config.apiEndpoint + 'resources/get-resources-by-pid/'+pid, options).map((res => res.json()))
        .catch(this.handleErrorObservable);
  }

  getPersonInfo(pid) {
    
    let token = this._token;
    let headers = new Headers({ 'Authorization': token });
    let options = new RequestOptions({ headers: headers });

    return this.http.get(this.config.apiEndpoint + 'resources/get-personinfo-by-pid/'+pid, options).map((res => res.json()))
        .catch(this.handleErrorObservable);
  }
  

  getSaveFormData(info: any): Observable<any> {
    /* let token = this._token;
    const headers = new Headers({'Authorization': token});
    return this.http.post(this.config.apiEndpoint + 'resources/get-applied-form', info, {
        headers: headers
      })
      .catch(this.handleErrorObservable); */
      let headers = new Headers({ 'Authorization': this._token });
      let options = new RequestOptions({ headers: headers });
      return this.http.post(this.config.apiEndpoint +'resources/get-applied-form', info, options)
        .map((res: Response) => res.json()) // ...and calling .json() on the response to return data
      .catch(this.handleErrorObservable); // ...errors if any

  }

  getLatestResources() {
    
    let token = this._token;
    let headers = new Headers({ 'Authorization': token });
    let options = new RequestOptions({ headers: headers });

    return this.http.get(this.config.apiEndpoint + 'resources/get-four-resources-by-pid', options).map((res => res.json()))
        .catch(this.handleErrorObservable);
  }

  resourceApplied(rid,pid) {
    
    let token = this._token;
    let headers = new Headers({ 'Authorization': token });
    let options = new RequestOptions({ headers: headers });

    return this.http.get(this.config.apiEndpoint + 'resources/resource-applied/'+rid+'/'+pid, options).map((res => res.json()))
        .catch(this.handleErrorObservable);
  }


  submitAppliedForm(info: any): Observable<any> {
    let token = this._token;
    const headers = new Headers({ 'Content-Type': 'application/json','Authorization': token});
    return this.http.post(this.config.apiEndpoint + 'resources/submit-applied-form', info, {
        headers: headers
      })
      .catch(this.handleErrorObservable);
  }

 removeResource(rid,pid)
 {
  let token = this._token;
  let headers = new Headers({ 'Authorization': token });
  let options = new RequestOptions({ headers: headers });

  return this.http.get(this.config.apiEndpoint + 'resources/remove-resource/'+rid+'/'+pid, options).map((res => res.json()))
      .catch(this.handleErrorObservable);
 }
  
  
  private handleErrorObservable (error: Response | any) {
    /*if(!error.json().error){
      alert('Please check your internet connection');
    }*/
    return Observable.throw( error.json().error || 'Server Error' );
  }
 
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/_services/student-resource.service.ts